const proxy = require("../proxy.json");

const gatewayMode = proxy.gatewayMode ?? "";
const prodUrl = proxy.gatewayUrl.prod ?? "";
const localUrl = proxy.gatewayUrl.local ?? "";
const testUrl = proxy.gatewayUrl.test ?? "";
const feVendorImpersonateProdUrl = proxy.feVendorImpersonateUrl?.prod ?? "";
const feVendorImpersonateLocalUrl = proxy.feVendorImpersonateUrl?.local ?? "";
const feVendorImpersonateTestUrl = proxy.feVendorImpersonateUrl?.test ?? "";

const api = (mode) => {
  let apiBaseUrl = "";
  switch (mode) {
    case "test":
      apiBaseUrl = `${testUrl}`;
      break;
    case "local":
      apiBaseUrl = `${localUrl}`;
      break;
    case "prod":
      apiBaseUrl = `${prodUrl}`;
      break;
    default:
      mode = "prod";
      apiBaseUrl = `${prodUrl}`;
      break;
  }
  apiBaseUrl = `${apiBaseUrl}/api`;

  // Vendor FE base URL (proxy.json feVendorImpersonateUrl) + bootstrap route in App.js.
  let feVendorImpersonateUrl = "";
  switch (mode) {
    case "test":
      feVendorImpersonateUrl = feVendorImpersonateTestUrl;
      break;
    case "local":
      feVendorImpersonateUrl = feVendorImpersonateLocalUrl;
      break;
    default:
      feVendorImpersonateUrl = feVendorImpersonateProdUrl;
      break;
  }

  return {
    apiMode: mode,
    apiBaseUrl,

    // LOGIN SERVICE /api/login/
    login: `${apiBaseUrl}/login/login`,
    refresh: `${apiBaseUrl}/login/refresh`,
    requestRecoverPassword: `${apiBaseUrl}/login/recover-password-request`,
    recoverPassword: `${apiBaseUrl}/login/recover-password`,
    impersonateVendor: `${apiBaseUrl}/login/vendor-impersonate`,

    // ADMIN SERVICE -> /api/admin/
    ricercaVendors: `${apiBaseUrl}/admin/vendors/ricerca`,
    allVendors: `${apiBaseUrl}/admin/vendors/all`,
    sendVendorPortalUpdateEmail: `${apiBaseUrl}/admin/vendors/portal-update-email`,
    vendorEmailRecipients: `${apiBaseUrl}/admin/vendors/email-recipients`,
    modificaVendor: `${apiBaseUrl}/admin/vendors/modifica`,
    vendorPaymentMethods: (vendorId) => `${apiBaseUrl}/admin/vendors/payment-methods/${vendorId}`,
    storicoVendors: `${apiBaseUrl}/admin/vendors/storico`,
    rollbackVendor: `${apiBaseUrl}/admin/vendors/rollback`,
    ricercaCatalog: `${apiBaseUrl}/admin/catalogs/ricerca`,
    associazioneCatalog: `${apiBaseUrl}/admin/catalogs/associazione`,
    modificaCatalog: `${apiBaseUrl}/admin/catalogs/modifica`,
    ricercaCategorie: `${apiBaseUrl}/admin/categories/ricerca`,
    allCategories: `${apiBaseUrl}/admin/categories/all`,
    ricercaUsers: `${apiBaseUrl}/admin/users/ricerca`,
    utenteElimina: `${apiBaseUrl}/admin/users/elimina`,
    ricercaNewsletter: `${apiBaseUrl}/admin/newsletter/ricerca`,
    newsletterDestinatari: `${apiBaseUrl}/admin/newsletter/destinatari`,
    newsletterPubblica: `${apiBaseUrl}/admin/newsletter/pubblica`,
    newsletterStoricoRicerca: `${apiBaseUrl}/admin/newsletter/storico/ricerca`,
    newsletterStoricoDettaglio: `${apiBaseUrl}/admin/newsletter/storico/dettaglio`,
    newsletterStoricoAnnulla: `${apiBaseUrl}/admin/newsletter/storico/annulla`,

    articleCategoriesList: `${apiBaseUrl}/admin/article-categories/list`,
    articleCategoriesSave: `${apiBaseUrl}/admin/article-categories/save`,
    articleCategoriesDelete: `${apiBaseUrl}/admin/article-categories/delete`,

    paymentMethodsList: `${apiBaseUrl}/admin/payment-methods/list`,
    paymentMethodsSave: `${apiBaseUrl}/admin/payment-methods/save`,
    paymentMethodsDelete: `${apiBaseUrl}/admin/payment-methods/delete`,

    articlesList: `${apiBaseUrl}/admin/articles/list`,
    articlesById: `${apiBaseUrl}/admin/articles/byId`,
    articlesSearch: `${apiBaseUrl}/admin/articles/search`,
    articlesSave: `${apiBaseUrl}/admin/articles/save`,
    articlesDelete: `${apiBaseUrl}/admin/articles/delete`,

    bannersList: `${apiBaseUrl}/admin/banners/list`,
    bannersUpload: `${apiBaseUrl}/admin/banners/upload`,
    bannersUpdate: `${apiBaseUrl}/admin/banners/update`,
    bannersDelete: `${apiBaseUrl}/admin/banners/delete`,

    storageBannerImageUpload: `${apiBaseUrl}/admin/storage/banner-image-upload`,
    storageBannerImageList: `${apiBaseUrl}/admin/storage/banner-image-list`,
    storageNewsletterImageUpload: `${apiBaseUrl}/admin/storage/newsletter-image-upload`,
    storageNewsletterImageList: `${apiBaseUrl}/admin/storage/newsletter-image-list`,
    storageArticleImageUpload: `${apiBaseUrl}/admin/storage/article-image-upload`,
    storageArticleImageList: `${apiBaseUrl}/admin/storage/article-image-list`,
    storageImageDelete: `${apiBaseUrl}/admin/storage/image-delete`,
    storagePrivateList: `${apiBaseUrl}/admin/storage/private-list`,
    storagePrivateLoad: `${apiBaseUrl}/admin/storage/private-load`,
    storagePrivateSave: `${apiBaseUrl}/admin/storage/private-save`,
    storagePrivateDelete: `${apiBaseUrl}/admin/storage/private-delete`,

    adminNotificationList: `${apiBaseUrl}/admin/notification/list`,
    adminNotificationState: `${apiBaseUrl}/admin/notification/state`,

    catalogMappingRicerca: `${apiBaseUrl}/admin/catalog-mapping/vendors/ricerca`,
    catalogMappingVendorDetail: `${apiBaseUrl}/admin/catalog-mapping/vendors/dettaglio`,
    catalogMappingGet: `${apiBaseUrl}/admin/catalog-mapping/dettaglio`,
    catalogMappingSave: `${apiBaseUrl}/admin/catalog-mapping/salva`,
    catalogMappingPreview: `${apiBaseUrl}/admin/catalog-mapping/preview`,
    catalogMappingCatalog: `${apiBaseUrl}/admin/catalog-mapping/catalog`,
    catalogMappingCatalogCell: `${apiBaseUrl}/admin/catalog-mapping/catalog/cell`,
    catalogMappingBulkCategorize: `${apiBaseUrl}/admin/catalog-mapping/catalog/bulk-categorize`,
    catalogMappingHardDelete: `${apiBaseUrl}/admin/catalog-mapping/catalog/hard-delete`,
    catalogMappingFieldKeys: `${apiBaseUrl}/admin/catalog-mapping/field-keys`,
    catalogMappingCategories: `${apiBaseUrl}/admin/catalog-mapping/categories`,
    catalogMappingRawFeed: `${apiBaseUrl}/admin/catalog-mapping/raw-feed`,
    catalogMappingRawDownload: `${apiBaseUrl}/admin/catalog-mapping/raw-feed/download`,
    catalogMappingRawUpload: `${apiBaseUrl}/admin/catalog-mapping/raw-feed/upload`,
    catalogMappingNormalize: `${apiBaseUrl}/admin/catalog-mapping/normalize`,
    catalogMappingNormalizedCell: `${apiBaseUrl}/admin/catalog-mapping/normalized-feed/cell`,
    catalogMappingNormalizedRowDelete: `${apiBaseUrl}/admin/catalog-mapping/normalized-feed/row/delete`,
    catalogMappingProductCodeRegenPreview: `${apiBaseUrl}/admin/catalog-mapping/product-code-regen/preview`,
    catalogMappingProductCodeRegenApply: `${apiBaseUrl}/admin/catalog-mapping/product-code-regen/apply`,
    catalogMappingProductCodeRegenOptions: `${apiBaseUrl}/admin/catalog-mapping/product-code-regen/options`,
    catalogImportStart: `${apiBaseUrl}/admin/catalog-mapping/import/start`,
    catalogImportLogs: `${apiBaseUrl}/admin/catalog-mapping/import/logs`,
    catalogImportStatus: `${apiBaseUrl}/admin/catalog-mapping/import/status`,
    catalogServiceStatus: `${apiBaseUrl}/admin/catalog-mapping/status`,
    catalogImportCancel: `${apiBaseUrl}/admin/catalog-mapping/import/cancel`,
    catalogServiceConfig: `${apiBaseUrl}/admin/catalog-mapping/service-config`,
    catalogServiceConfigUpdate: `${apiBaseUrl}/admin/catalog-mapping/service-config/update`,

    adminPermissionsGet: `${apiBaseUrl}/admin/settings/get-permissions`,
    adminPermissionsUpdate: `${apiBaseUrl}/admin/settings/update-permissions`,
    catalogServiceConfigSettingsGet: `${apiBaseUrl}/admin/settings/get-catalog-service-config`,
    catalogServiceConfigSettingsUpdate: `${apiBaseUrl}/admin/settings/update-catalog-service-config`,

    reindexStatus: `${apiBaseUrl}/admin/reindex/status`,
    reindexFull: `${apiBaseUrl}/admin/reindex/full`,
    reindexVendor: (vendorId) => `${apiBaseUrl}/admin/reindex/vendor/${vendorId}`,

    cacheRefreshCategories: `${apiBaseUrl}/admin/cache/re-cache-categories`,
    cacheRefreshSelectedProducts: `${apiBaseUrl}/admin/cache/re-cache-selected-products`,
    cacheRefreshVendors: `${apiBaseUrl}/admin/cache/re-cache-vendors`,
    cacheRefreshBanners: `${apiBaseUrl}/admin/cache/re-cache-banners`,
    cacheDataStatus: `${apiBaseUrl}/admin/cache/data-status`,
    cacheSyncNextDataStatus: `${apiBaseUrl}/admin/cache/sync-next-data-status`,
    runtimeNextStatus: `${apiBaseUrl}/admin/runtime/next-status`,

    vendorTicketList: `${apiBaseUrl}/admin/vendor-ticket/list`,
    vendorTicketAssign: `${apiBaseUrl}/admin/vendor-ticket/assign`,
    vendorTicketClose: `${apiBaseUrl}/admin/vendor-ticket/close`,
    vendorTicketReopen: `${apiBaseUrl}/admin/vendor-ticket/reopen`,
    vendorTicketMessage: `${apiBaseUrl}/admin/vendor-ticket/message`,
    vendorTicketMessageList: `${apiBaseUrl}/admin/vendor-ticket/message/list`,
    vendorTicketMessageAttachment: `${apiBaseUrl}/admin/vendor-ticket/message/attachment`,
    vendorTicketMessageEdit: `${apiBaseUrl}/admin/vendor-ticket/message/edit`,
    vendorTicketSummary: `${apiBaseUrl}/admin/vendor-ticket/summary`,
    vendorTicketAssigneesList: `${apiBaseUrl}/admin/vendor-ticket/assignees/list`,
    vendorTicketMessagePoll: `${apiBaseUrl}/admin/vendor-ticket/message/poll`,

    // CLICK & STATS SERVICE
    statsCatalog: `${apiBaseUrl}/click/click`,
    trafficStats: `${apiBaseUrl}/click/admin-stats/traffic`,
    trafficStatsProducts: `${apiBaseUrl}/click/admin-stats/top-products`,
    trafficStatsCategories: `${apiBaseUrl}/click/admin-stats/top-categories`,
    trafficStatsRegistrations: `${apiBaseUrl}/click/admin-stats/registrations`,

    // REDIRECT URLS
    feVendorImpersonateLogin: `${feVendorImpersonateUrl}/impersonate-login`,

    // BILLING SERVICE
    syncStripeCustomers: `${apiBaseUrl}/biling/customer/sync`,
    getCustomerBalance: (vendorId) => `${apiBaseUrl}/biling/customer/balance/${vendorId}`,
    addVendorCredit: (vendorId) => `${apiBaseUrl}/biling/customer/add-credit/${vendorId}`,
    getVendorTransactions: (vendorId) => `${apiBaseUrl}/biling/customer/transactions/${vendorId}`,
    getStripeSettings: `${apiBaseUrl}/biling/admin/stripe-settings`,
    updateStripeSettings: `${apiBaseUrl}/biling/admin/stripe-settings`,
  };
};

export default api(gatewayMode);
